export default __webpack_public_path__ + "static/media/alert-triangle.d14e8c36.svg";